import { useEffect, useRef, useState } from "react";
import { Button, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { dashboard, nonParentCategories } from "../slice";

import { findProductIdBy } from "@app/modules/categories/slice";
import { useDialog, useRequestState } from "@app/hooks";
import { BuyAndSellCarsOnline } from "@app/modules/landing";
import { Testimonial, VisionCards } from "@app/components";
import { selectIsAuthenticated } from "@app/modules/common";

import { HeroSection } from "./hero-sections";
import { AllCarsSection } from "./all-cars-sections";
import { UsedCarsSection } from "./used-cars-sections";
import { NewCarsSection } from "./new-cars-sections";
import { selectCarTypeState, selectNonParentCategories } from "../selector";
import { dummyDashboardData } from "./dummy-data";
import { NumberBanner } from "./numbersBanner";
import ProductList from "./Product-list";
import BrowseByPrice from "./browseByPrice";
import { HomeVisionData, numberData } from "@app/mock/homeData";
import { vehiclesData } from "@app/mock/vehiclesData";

const ITEMS_PER_PAGE = 9;

const HomePage = () => {
  const handleDoubleCallDashboardApi = useRef(false);
  const handleDoubleCallNonParentApi = useRef(false);
  const popupShownOnce = useRef(false);
  const [activeFilter, setActiveFilter] = useState({
    name: Strings.home.allVehicles,
    id: 0,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const BuyAndSellCarsOnlineDialog = useDialog();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { data: dashboardData } = useRequestState({
    stateSelector: selectCarTypeState,
  });

  const { data: nonParentCategoriesData } = useRequestState({
    stateSelector: selectNonParentCategories,
  });

  const featuredCars = dashboardData?.freshRecommendation || [];
  const latestCars = dashboardData?.latestCars || [];
  const popularCars = dashboardData?.popularCars || [];
  const mostSearchedCars = dashboardData?.mostSearchedCars || [];

  const allCarsTotalPages = Math.ceil(featuredCars.length / ITEMS_PER_PAGE);
  const usedCarsTotalPages = Math.ceil(latestCars.length / ITEMS_PER_PAGE);
  const newCarsTotalPages = Math.ceil(popularCars.length / ITEMS_PER_PAGE);

  useEffect(() => {
    const carTypeToSend =
      activeFilter?.name === Strings.home.allVehicles ? "" : activeFilter?.name;
    if (handleDoubleCallDashboardApi.current) return;
    handleDoubleCallDashboardApi.current = true;
    dispatch(dashboard({ carType: carTypeToSend } as any));
  }, [dispatch, activeFilter]);

  useEffect(() => {
    if (handleDoubleCallNonParentApi.current) return;
    handleDoubleCallNonParentApi.current = true;
    dispatch(nonParentCategories());
  }, []);

  useEffect(() => {
    if (
      // !isAuthenticated &&
      !popupShownOnce?.current
    ) {
      BuyAndSellCarsOnlineDialog.show();
      popupShownOnce.current = true;
    }

    // if (isAuthenticated) {
    //   BuyAndSellCarsOnlineDialog.hide();
    // }
  }, [isAuthenticated, BuyAndSellCarsOnlineDialog]);

  return (
    <Stack sx={{ pb: 2 }}>
      <HeroSection
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        nonParentCategoriesData={nonParentCategoriesData}
      />

      <ProductList
        name={Strings.home.freshRecommendation}
        vehicles={featuredCars}
        isScrollable={false}
      />
      <ProductList name={Strings.home.latestCar} vehicles={latestCars} />
      <BrowseByPrice />
      <ProductList
        name={Strings.home.mostSearchedCars}
        vehicles={mostSearchedCars}
      />

      {BuyAndSellCarsOnlineDialog.visible && (
        <BuyAndSellCarsOnline
          open={BuyAndSellCarsOnlineDialog.visible}
          onClose={BuyAndSellCarsOnlineDialog.hide}
        />
      )}

      <ProductList name={Strings.home.popularCars} vehicles={popularCars} />
      <NumberBanner data={numberData} />
      <VisionCards heading={Strings.heading.ourVision} items={HomeVisionData} />
      <Testimonial />
    </Stack>
  );
};

export { HomePage };
